import createVueApp from '@/common/createApp'

Styxie.Initializers.MomentsClientReviews = {
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/moments/client_reviews/show.vue')
    // Public page — no AppLayout, no global store. createVueApp falls back
    // to mounting the component directly when the global store isn't
    // populated, which is exactly what we want here.
    createVueApp(ShowPage, { props, layout: null })
  }
}
